<div class="p-4 max-w-4xl mx-auto">
  <div class="mb-4">
    <p-button label="Volver al listado" icon="pi pi-arrow-left" styleClass="p-button-text" (onClick)="goBack()"></p-button>
  </div>

  <form [formGroup]="webhookForm" (ngSubmit)="onSubmit()">
    <p-card [header]="isEdit() ? 'Editar webhook' : 'Nuevo webhook'">
      <div class="flex flex-col gap-6">

        <div
          class="relative overflow-hidden rounded-2xl border-2 p-6 shadow-xl transition-all duration-300"
          [ngClass]="
            webhookForm.get('enabled')?.value
              ? 'border-emerald-400/50 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-900 shadow-emerald-600/25'
              : 'border-slate-200/90 bg-gradient-to-br from-slate-100 via-slate-50 to-white shadow-slate-300/40'
          "
        >
          <div class="relative flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
            <div class="flex flex-1 items-start gap-4">
              <div
                class="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl shadow-lg ring-2"
                [ngClass]="
                  webhookForm.get('enabled')?.value
                    ? 'bg-white/20 ring-white/40'
                    : 'bg-white ring-slate-200/80'
                "
              >
                <i
                  class="pi text-2xl"
                  [ngClass]="webhookForm.get('enabled')?.value ? 'pi-bolt text-amber-200' : 'pi-power-off text-slate-400'"
                ></i>
              </div>
              <div class="min-w-0 pt-0.5">
                <p
                  class="mb-1 text-xs font-bold uppercase tracking-[0.2em]"
                  [ngClass]="webhookForm.get('enabled')?.value ? 'text-emerald-100/90' : 'text-slate-500'"
                >
                  Estado del endpoint
                </p>
                <h2
                  class="mb-1 text-xl font-bold leading-tight"
                  [ngClass]="webhookForm.get('enabled')?.value ? 'text-white' : 'text-slate-900'"
                >
                  {{ webhookForm.get('enabled')?.value ? 'Activo — recibirá eventos suscritos' : 'Inactivo — sin envíos' }}
                </h2>
                <p
                  class="m-0 max-w-xl text-sm leading-relaxed"
                  [ngClass]="webhookForm.get('enabled')?.value ? 'text-emerald-50/95' : 'text-slate-600'"
                >
                  Solo se enviarán a este endpoint los eventos que marques abajo.
                </p>
              </div>
            </div>

            <div
              class="flex shrink-0 items-center gap-3 rounded-xl border px-4 py-3"
              [ngClass]="webhookForm.get('enabled')?.value ? 'border-white/25 bg-black/10' : 'border-slate-200 bg-white/80'"
            >
              <span
                class="text-sm font-semibold"
                [ngClass]="webhookForm.get('enabled')?.value ? 'text-white' : 'text-slate-700'"
              >
                {{ webhookForm.get('enabled')?.value ? 'Activado' : 'Desactivado' }}
              </span>
              <p-toggleswitch formControlName="enabled" inputId="webhookEnabled" [size]="'large'" />
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <label for="endpoint" class="font-semibold">Endpoint URL *</label>
          <input pInputText id="endpoint" formControlName="endpoint" placeholder="https://api.example.com/webhook" class="w-full" />
          <small class="text-red-500" *ngIf="webhookForm.get('endpoint')?.touched && webhookForm.get('endpoint')?.invalid">
            La URL es requerida y debe ser válida
          </small>
        </div>

        <div class="flex flex-col gap-2">
          <label for="description" class="font-semibold">Descripción</label>
          <input pInputText id="description" formControlName="description" placeholder="Webhook de producción / staging" class="w-full" />
        </div>

        @if (currentWebhook()?.secret) {
          <div class="flex flex-col gap-2 rounded-xl border border-amber-200 bg-amber-50/80 p-4">
            <div class="flex items-center justify-between gap-2">
              <label class="font-semibold text-amber-950">Signing secret</label>
              <p-button label="Copiar" icon="pi pi-copy" size="small" severity="secondary" type="button" (onClick)="copySecret()" />
            </div>
            <code class="break-all text-sm text-amber-950 font-mono">{{ currentWebhook()?.secret }}</code>
            <p class="m-0 text-xs text-amber-800/90">
              Úsalo para validar <code>Pento-Signature</code> en tu servidor. Trátalo como una contraseña.
            </p>
          </div>
        }

        <div class="flex flex-col gap-3">
          <div>
            <h3 class="font-semibold text-slate-900 m-0">Eventos a recibir *</h3>
            <p class="text-sm text-slate-500 mt-1 mb-0">Marca los eventos que este endpoint debe recibir.</p>
          </div>

          <div class="grid gap-4 md:grid-cols-2">
            @for (group of eventGroups; track group.key) {
              <div class="rounded-xl border border-slate-200 bg-slate-50/60 p-4">
                <div class="mb-3 flex items-center gap-2 border-b border-slate-200 pb-2">
                    <p-checkbox
                    [binary]="true"
                    [ngModel]="isGroupFullySelected(group)"
                    [ngModelOptions]="{standalone: true}"
                    (onChange)="toggleGroup(group, $event.checked === true)"
                    [inputId]="'group-' + group.key" />
                  <label [for]="'group-' + group.key" class="font-semibold text-slate-800 cursor-pointer">{{ group.label }}</label>
                </div>
                <div class="flex flex-col gap-2 pl-1">
                  @for (ev of group.events; track ev.value) {
                    <div class="flex items-center gap-2">
                      <p-checkbox
                        [binary]="true"
                        [ngModel]="isEventSelected(ev.value)"
                        [ngModelOptions]="{standalone: true}"
                        (onChange)="toggleEvent(ev.value, $event.checked === true)"
                        [inputId]="'ev-' + ev.value" />
                      <label [for]="'ev-' + ev.value" class="text-sm text-slate-700 cursor-pointer font-mono">{{ ev.label }}</label>
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <small class="text-red-500" *ngIf="subscribedEventsControl.touched && subscribedEventsControl.invalid">
            Selecciona al menos un evento
          </small>
        </div>

        <div class="flex flex-col gap-2">
          <div class="flex justify-between items-center">
            <label class="font-semibold">Headers personalizados</label>
            <p-button label="Agregar Header" icon="pi pi-plus" size="small" (onClick)="addHeader()" type="button" severity="secondary"></p-button>
          </div>

          <div formArrayName="headers" class="flex flex-col gap-2">
            <div *ngFor="let header of headersArray.controls; let i = index" [formGroupName]="i" class="flex gap-2 items-start">
              <div class="flex-1">
                <input pInputText formControlName="key" placeholder="Key (e.g. Authorization)" class="w-full" />
              </div>
              <div class="flex-1">
                <input pInputText formControlName="value" placeholder="Value" class="w-full" />
              </div>
              <p-button icon="pi pi-trash" severity="danger" (onClick)="removeHeader(i)" type="button"></p-button>
            </div>
            <div *ngIf="headersArray.controls.length === 0" class="text-gray-500 italic text-sm">
              No hay headers configurados.
            </div>
          </div>
        </div>

      </div>

      <ng-template pTemplate="footer">
        <div class="!mt-4 flex justify-end gap-4 mt-1 !p-4 !-m-5 bg-gray-50 p-2 border-t border-slate-200">
          <p-button label="Cancelar" severity="secondary" (onClick)="goBack()" type="button" />
          <p-button [label]="isEdit() ? 'Guardar cambios' : 'Crear webhook'" icon="pi pi-save" type="submit" [loading]="loading()"></p-button>
        </div>
      </ng-template>
    </p-card>
  </form>
</div>
